import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { RightColumnProvider } from 'Context/RightColumnContext';
import ThreadRoutingDetailsContent
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadRoutingDetails/Content';
import ThreadHistoryPicker
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHistoryPicker';

const ThreadRoutingDetails = ({ resource }) => {
  return (
    <RightColumnProvider>
      <ThreadRoutingDetailsContent resource={resource} />
      <ThreadHistoryPicker />
    </RightColumnProvider>
  );
};

ThreadRoutingDetails.defaultProps = {
};

ThreadRoutingDetails.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ThreadRoutingDetails;
